export default {
  INTERESTED: 'interested',
  NOT_INTERESTED: 'not_interested',
  UNANSWERED: 'unanswered',
}
